/* External */
import queryString from 'query-string';

/**
 * @enum {string}
 * @readonly
 */
export const DataSerializeType = {
  NONE: 'none',
  FORM_URL_ENCODED: 'form-url-encoded',
};

/**
 * @typedef DataSerializeConfig
 * @type {object}
 * @property {DataSerializeType} [dataSerializeType]
 */

/**
 * @param {DataSerializeConfig & import('axios').AxiosRequestConfig} param0
 */
function interceptor({ dataSerializeType, ...axiosRequestConfig }) {
  const { data } = axiosRequestConfig;
  let serializedData;

  switch (dataSerializeType) {
    case DataSerializeType.FORM_URL_ENCODED:
      serializedData = queryString.stringify(data);
      break;
    case DataSerializeType.NONE:
    default:
      return axiosRequestConfig;
  }

  return { ...axiosRequestConfig, data: serializedData };
}

export function createDataSerializerInterceptor() {
  return interceptor;
}
